module.exports = __webpack_public_path__ + "static/media/avatar.94b06ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Static/image/avatar.png
// module id = 400
// module chunks = 0